<div class="container chat-container" [class.full-screen-mode]="isFullScreen">
  <div class="chat-wrapper">
    <div class="chat-header">
      <div class="bot-info">
        <div class="bot-avatar">
          <img src="../../../../assets/LogoSoloBoris.png" alt="Boris AI" />
        </div>
        <div>
          <h3 class="bot-name">Boris</h3>
          <span class="bot-status" [class.online]="isOnline" [class.offline]="!isOnline">
            ● {{ isOnline ? 'En línea' : 'Desconectado' }}
          </span>
        </div>
      </div>
      <div class="chat-mode-selector" *ngIf="isAdmin">
        <button class="btn-mode" [class.active]="chatMode === 'documentos'" (click)="selectChatMode('documentos')">
          Documentos
        </button>
        <button class="btn-mode" [class.active]="chatMode === 'cdt'" (click)="selectChatMode('cdt')">
          KPIs CDT / Ahorro
        </button>
      </div>
      <div class="header-actions">
        <button class="btn-action btn-download" (click)="downloadChatBackup()"
          title="Descargar respaldo del chat"
          [disabled]="messages.length === 0">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
        </button>
        <button class="btn-action" (click)="toggleFullScreen()"
          [title]="isFullScreen ? 'Salir de pantalla completa' : 'Pantalla completa'">
          <svg *ngIf="!isFullScreen" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 3 21 3 21 9"></polyline>
            <polyline points="9 21 3 21 3 15"></polyline>
            <line x1="21" y1="3" x2="14" y2="10"></line>
            <line x1="3" y1="21" x2="10" y2="14"></line>
          </svg>
          <svg *ngIf="isFullScreen" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="4 14 10 14 10 20"></polyline>
            <polyline points="20 10 14 10 14 4"></polyline>
            <line x1="14" y1="10" x2="21" y2="3"></line>
            <line x1="3" y1="21" x2="10" y2="14"></line>
          </svg>
        </button>
        <button class="btn-action btn-clear" (click)="clearChat()" title="Limpiar conversación">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            <line x1="10" y1="11" x2="10" y2="17"></line>
            <line x1="14" y1="11" x2="14" y2="17"></line>
          </svg>
        </button>
      </div>
    </div>

    <div class="chat-messages-container">
      <div class="chat-messages" #scrollMe (scroll)="onMessagesScroll()">
        <div *ngFor="let msg of messages" class="message-wrapper"
          [ngClass]="{'user-wrapper': msg.sender === 'user', 'bot-wrapper': msg.sender === 'bot'}">

          <div *ngIf="msg.sender === 'bot'" class="avatar-small">
            <img src="../../../../assets/LogoSoloBoris.png" alt="Bot" />
          </div>

          <div class="message-bubble"
            [ngClass]="{'user-bubble': msg.sender === 'user', 'bot-bubble': msg.sender === 'bot', 'error-bubble': msg.error}">

            <div *ngIf="msg.isLoading" class="typing-indicator">
              <span></span><span></span><span></span>
            </div>

            <div *ngIf="!msg.isLoading" class="message-content" [innerHTML]="formatMessage(msg)"></div>

            <div class="message-time" *ngIf="!msg.isLoading">
              {{ msg.timestamp | date:'shortTime' }}
            </div>
          </div>
        </div>
      </div>

      <button *ngIf="showScrollToBottom" class="scroll-fab" type="button"
        (click)="scrollToLatest()" [attr.aria-label]="'Ir al final'" title="Ir al final">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
        <span *ngIf="unseenMessages > 0" class="scroll-fab-badge">{{ unseenMessages }}</span>
      </button>
    </div>

    <div class="chat-input-area">
      <div class="input-wrapper">
        <textarea [(ngModel)]="newMessage" (keydown)="handleKeyPress($event)"
          (input)="onTextareaInput($event)"
          [placeholder]="inputPlaceholder"
          rows="1"
          [disabled]="isLoading || !isOnline"
          aria-label="Mensaje para Boris">
        </textarea>
        <button class="btn-send" (click)="sendMessage()" [disabled]="!newMessage.trim() || isLoading || !isOnline">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
          </svg>
        </button>
      </div>
      <div class="chat-footer-text">
        <span *ngIf="isOnline">
          {{ footerText }}
          <span class="kbd-hint"><kbd>Enter</kbd> enviar &middot; <kbd>Shift</kbd>+<kbd>Enter</kbd> salto de línea</span>
        </span>
        <span *ngIf="!isOnline" class="offline-warning">⚠️ Chat desconectado. Verificando conexión...</span>
      </div>
    </div>
  </div>
</div>

<app-confirmation-modal [isVisible]="showClearChatModal"
  confirmationText="¿Estás seguro de que deseas limpiar la conversación?" confirmButtonText="Aceptar"
  (confirmed)="confirmClearChat()" (canceled)="cancelClearChat()">
</app-confirmation-modal>